import { render, staticRenderFns } from "./WoltSettings.vue?vue&type=template&id=7b9852ce"
import script from "./WoltSettings.vue?vue&type=script&lang=js"
export * from "./WoltSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports